export function toUTCDateOnly(date: Date): Date {
  const f = new Date(date);
  const year = f.getUTCFullYear();
  const month = f.getUTCMonth();
  const day = f.getUTCDate();

  return new Date(Date.UTC(year, month, day));
}
